
import AccordionTransition from "./AccordionTransition"

export default {
  components: {
    AccordionTransition
  },
  props: {
    isAccordionGrey: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpen: false
    }
  }
}
